export default "<app-talks></app-talks>"